import { IconAvatar } from '@/blocks/components/Icons/Avatar';
import { CheckCircle } from '@/blocks/components/Icons/CheckCircle';
import { WithClassName } from '@/blocks/components/types';
import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';

type StrategyAvatarProps = {
  strategyId: number;
  verified?: boolean;
  showVerified?: boolean;
} & WithClassName;

export function StrategyAvatar(props: StrategyAvatarProps) {
  return (
    <div className={classNames(styles.avatar, props.className)}>
      <IconAvatar />
      <div className={styles.avatarVerifiedIndicator}>
        {props.verified && props.showVerified ? <CheckCircle /> : null}
      </div>
    </div>
  );
}
